import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Input, { InputAdornment } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import Select from "material-ui/Select";
import HelpIcon from "../Icons/HelpIcon";
import Add from "../Icons/Add";
import Button from "../Parts/Button";
import ArrowToolTip from "../common/ArrowToolTip";
import { FormControlLabel } from "material-ui/Form";
import Switch from "material-ui/Switch";

import { formatName, addCommas } from "../../utils/utils";
import { ADD_ORDER_CONTACT } from "../../constants/Constants";

const styles = () => ({
  root: {
    width: "100%",
    boxSizing: "border-box",
    padding: "0px 15px",
  },

  row: {
    height: "65px",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #F4F6F9",
  },

  backBtn: {
    fontSize: 15,
    color: "#000000",
    backgroundColor: "#ECEDEF",
    width: 120,
    height: 40,
    marginRight: 30,
    border: 'none',
  },

  tag: {
    background: "#F0F2F4 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    padding: "4px 6px",
    color: "#5A5B62",
    fontSize: "12px",
    marginRight: "10px",
  },

  name: {
    color: "#181819",
    fontSize: "13px",
    fontWeight: "bold",
  },

  count: {
    color: "#181819",
    fontSize: "13px",
    marginLeft: "10px",
  },

  estimateDelivery: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
  },

  estimateDeliveryText: {
    color: "#014377",
    fontSize: "13px",
  },

  textItem: {
    padding: "0px 10px",
    borderBottom: "solid 1px #ced4da",
    width: "200px",
    alignItems: "center",
    marginRight: "20px",
  },

  input: {
    color: "black",
    textAlign: "right",
    fontSize: "18px",
    fontWeight: "bold",
    width: "50%",
    padding: "3.5px 0",
    borderWidth: "0",
    height: "33px",
    boxSizing: "border-box",
  },

  select: {
    color: "black",
    borderBottom: "1px solid #ced4da",
    fontSize: "13px",
    borderWidth: "0",
    height: "33px",
    boxSizing: "border-box",
    padding: "6px 36px 0px 5px",
    minWidth: "150px",
  },

  arrow: {
    position: "absolute",
    fontSize: 6,
    top: 0,
    left: "calc(50% - 1.5em)",
    marginTop: "-0.95em",
    width: "3em",
    height: "1em",

    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "0em 1em 1em 1em",
      borderColor: `transparent transparent #181819 transparent`,
    },
  },

  tooltip: {
    fontWeight: 200,
    fontSize: 13,
    width: 200,
    backgroundColor: "#181819",
    padding: "12px 15px",
    opacity: 1,
  },

  arrowClass: {
    position: "absolute",
    fontSize: 6,
    top: 0,
    left: "calc(85% - 1.5em)",
    marginTop: "-0.95em",
    width: "3em",
    height: "1em",

    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "0em 1em 1em 1em",
      borderColor: `transparent transparent #181819 transparent`,
    },
  },

  item: {
    display: "flex",
    alignItems: "center",
    marginRight: "10px",
  },

  label: {
    padding: "4px 2px",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "12px",
    marginRight: "10px",
  },

  switchBase: {
    height: "unset",
  },
});

class SendLetterHeader extends React.Component {
  state = {
    disableSwitch: true,
    warningMessage: "",
    salesforce_sync_flag: false,
  };

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.updateState();
    }
  }

  updateState = () => {
    const {
      user,
      address_import_mappings_flag,
      exe_export_mappings_flag,
      isExe,
    } = this.props;
    let { disableSwitch, warningMessage, salesforce_sync_flag } = this.state;

    if (
      user &&
      user.salesforce_integration_flag &&
      user.integrations &&
      user.integrations["salesforce"]
    ) {
      if (isExe && !exe_export_mappings_flag) {
        disableSwitch = true;
        salesforce_sync_flag = false;
        warningMessage =
          "キーマンデータベースからの注文をSalesforceに同期するには、連携設定が必要です。「アカウント管理 > Salesforce連携」より設定してください。";
      } else if (!isExe && !address_import_mappings_flag) {
        disableSwitch = true;
        salesforce_sync_flag = false;
        warningMessage =
          "自社リストからの注文をSalesforceに同期するには、連携設定が必要です。「アカウント管理 > Salesforce連携」より設定してください。";
      } else {
        salesforce_sync_flag = true;
        disableSwitch = false;
        warningMessage = "";
      }
    } else {
      disableSwitch = true;
      salesforce_sync_flag = false;
      warningMessage =
        "Salesforce連携が未設定か、お客様現在のプランには含まれていません。";
    }

    this.setState({
      salesforce_sync_flag: salesforce_sync_flag,
      warningMessage: warningMessage,
      disableSwitch: disableSwitch,
    });

    this.props.handleToggleSalesforceSyncFlag(salesforce_sync_flag);
  };

  handleToggleSalesforceSyncFlag = (e) => {
    this.setState({
      salesforce_sync_flag: e.target.checked,
    });

    this.props.handleToggleSalesforceSyncFlag(e.target.checked);
  };

  render() {
    const {
      classes,
      item,
      disableButton,
      user,
      isMulti,
      selectCount,
      name,
      orderContacts,
      disableMessage,
    } = this.props;

    const { disableSwitch, warningMessage, salesforce_sync_flag } = this.state;

    //let beforeNoon = moment().diff(moment().hour(12).minutes(0).seconds(0)) < 0;

    let backBtn = (
      <Button
        text="戻る"
        size="small"
        className={classes.backBtn}
        handleClickButton={this.props.goBack}
      />
    );

    let max_annual_letter_num =
      user && user.active_plan && user.active_plan.max_annual_letter_num
        ? user.active_plan.max_annual_letter_num
        : null;
    let sent_count = user ? user.active_plan_letter_count : 0;
    let inputValue = `${addCommas(sent_count)}${max_annual_letter_num ? "/" + addCommas(max_annual_letter_num) : ""
      }`;

    return (
      <div className={classes.root}>
        <div className={classes.row}>
          {backBtn}
          <div className={classes.tag}>送付先</div>
          <div className={classes.name}>
            {isMulti ? name + " 様" : formatName(item, "様")}
          </div>
          {isMulti && selectCount > 1 && (
            <div className={classes.count}>
              他{addCommas(selectCount - 1)}件
            </div>
          )}

          {/*<div className={classes.estimateDelivery}>
            <div className={classes.estimateDeliveryText}>
              {beforeNoon ? '本日12時まで' : '翌日'}の注文で{this.props.shippingScheduledAt.format("YYYY年MM月DD日")}に発送予定
            </div>
            <ArrowToolTip
              style={{ margin: '-2px 2px 0px 2px' }}
              text="到着日は発送予定日の１〜２日後となります。"
              placement="bottom"
            >
              <HelpIcon width={15} height={15} color="#71737B" />
            </ArrowToolTip>
          </div>*/}

          <div className="flex"></div>

          <div className={classes.item} style={{ marginRight: 0 }}>
            <div className={classes.item}>
              <div
                className={classes.label}
                style={{
                  marginRight: "0px",
                  color: salesforce_sync_flag
                    ? "#1A65FF"
                    : "rgba(0, 0, 0, 0.54)",
                }}
              >
                Salesforceに同期する
              </div>
              <ArrowToolTip
                style={{ margin: "-2px 2px 0px 2px" }}
                text="「Salesforceに同期する」オプションがオンの場合、この注文はSalesforceキャンペーンに同期されます。もし注文がキーマンデータベースから作られている場合、リストに含まれるキーマンも、指定されたSalesforceのオブジェクトに同期されます。もし注文が自社リストから作られていて、そして宛先にSalesforceによるインポートされたアドレスが1件も含まれていない場合、注文はSalesforceキャンペーンには同期されません。"
                placement="top"
              >
                <HelpIcon
                  width={15}
                  height={15}
                  color={salesforce_sync_flag ? "#1A65FF" : "#71737B"}
                />
              </ArrowToolTip>
            </div>

            <ArrowToolTip
              style={{ margin: "-2px 2px 0px 2px" }}
              text={warningMessage}
              placement="top"
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={salesforce_sync_flag}
                    onChange={this.handleToggleSalesforceSyncFlag}
                    value="salesforce_sync_flag"
                    color="primary"
                    classes={{
                      root: classes.switchBase,
                    }}
                    disabled={disableSwitch}
                    title={warningMessage}
                  />
                }
                className={classes.formControlLabel}
              />
            </ArrowToolTip>
          </div>

          <div className={classes.item}>
            <div className={classes.tag} style={{ marginRight: "0px" }}>
              注文担当者
            </div>
            <ArrowToolTip
              style={{ margin: "-2px 2px 0px 2px" }}
              text="注文担当者情報の管理はアカウント管理より行えます。"
              placement="top"
            >
              <HelpIcon width={15} height={15} color="#71737B" />
            </ArrowToolTip>
            <FormControl style={{ margin: "0 8px 0 10px" }}>
              <Select
                value={this.props.orderContactId}
                onChange={this.props.handleChangeOrderContact}
                classes={{
                  select: classes.select,
                }}
              >
                {this.props.orderContactId === -1 && (
                  <MenuItem key={-1} value={-1}>
                    選択してください
                  </MenuItem>
                )}
                {orderContacts.map((contact, i) => (
                  <MenuItem key={i} value={contact.id}>
                    {contact.name}
                  </MenuItem>
                ))}
                <MenuItem key={-2} value={ADD_ORDER_CONTACT}>
                  <Add width={17} height={17} />
                  担当者を新規登録
                </MenuItem>
              </Select>
            </FormControl>
          </div>

          <FormControl>
            <Input
              disabled
              startAdornment={
                <InputAdornment position="start" style={{ fontSize: "11px" }}>
                  現在のプランでの<br />送付通数
                </InputAdornment>
              }
              value={inputValue}
              className={classes.textItem}
              classes={{ input: classes.input }}
              disableUnderline
            />
          </FormControl>

          <ArrowToolTip
            style={{ margin: "-2px 2px 0px 2px" }}
            text={disableMessage}
            placement="top"
          >
            <div>
              <Button
                text="次へ"
                size="small"
                handleClickButton={
                  user && !user.send_letter_flag
                    ? this.props.togglePlanDialog
                    : this.props.order
                }
                disabled={disableButton}
                style={{
                  padding: "0 70px",
                  backgroundColor: "#2E68F6",
                  height: 40,
                }}
              />
            </div>
          </ArrowToolTip>
        </div>
      </div>
    );
  }
}

SendLetterHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  item: PropTypes.object,
  disableButton: PropTypes.bool,
  order: PropTypes.func.isRequired,
  user: PropTypes.object,
  isMulti: PropTypes.bool,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  orderContacts: PropTypes.array,
  handleChangeOrderContact: PropTypes.func,
  orderContactId: PropTypes.number,
  handleToggleSalesforceSyncFlag: PropTypes.func,
  isExe: PropTypes.bool,
  disableMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  togglePlanDialog: PropTypes.func,
  address_import_mappings_flag: PropTypes.bool,
  exe_export_mappings_flag: PropTypes.bool,
};

export default withStyles(styles)(SendLetterHeader);



// WEBPACK FOOTER //
// ./src/components/SendLetter/SendLetterHeader.jsx